<!-- <IFA-header></IFA-header> -->
<main role="main">

  <main class="pro-calculator bg-apricot">

    <div class="container" id="Optimum-wealth-home">
      <div class="wealth-creation-features wealth-section-space pb-0 mobilemt-40">
        <div class="container pt-4">
          <div class="row">
            <div class="col-12">
              <div class='d-flex flex-row'>
                <div class='flex-fill'>
                  <div class="col-12 mt-2">
                    <div class="sb-tag sb-offerings mb-12">
                      calculator
                    </div>
                    <h2 class="wealth-section-title mb-6">
                      Mutual Fund Returns Calculator
                    </h2>
                    <p class="wealth-section-description">
                      Mutual funds are an excellent way to achieve any of your investment objectives. To calculate
                      the
                      capital gain and maturity amount of your mutual fund assets, use a mutual fund returns
                      calculator.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-12 col-xs-12 col-sm-12  no-gutters Optimum-feature-carousel mt-30 mobilemt-0">
            <!-- <iframe src="iframe-calculator" class="mobileHeightIframe" width="100%" height="790px;"
            scrolling="no"></iframe> -->
            <main class="pro-calculator whtbg" style="width:100%">


              <section class="section sec-calculator sec-other-calculator pt-0 mtb-0" id="" style="padding-top: 0px;">

                <div class="main-content row-inner MobCal">
                  <div class="d-none">
                    <div class="sip-window">
                      <div class="cal-tax-exemption">
                        <div class="tax-form-heading row-flex justify-content-center">
                        </div>
                        <div class="tax-form-heading row-flex justify-content-center">
                          <ul class="switch-time mf-switch">
                            <li class="active" data-attr="SIP">Monthly - SIP</li>
                            <li data-attr="Lumpsum" style="padding: 10px 0px;">Lumpsum</li>
                          </ul>
                        </div>
                        <div class="calculator-form pt-10">
                          <div class="row-flex hide">
                            <div class="flex-with-no-space detailType">
                              <label class="radio-btn type2 mrgn19"> <input type="radio" class="radio-btn-input circle"
                                  checked name="i_know" value="investmentDetails" /><span></span> I know investment
                                amount </label>
                              <label class="radio-btn type2"> <input type="radio" class="radio-btn-input circle"
                                  name="i_know" value="goalDetails" /><span></span> I know the target amount </label>
                            </div>
                          </div>
                          <div class="row-flex">
                            <div class="form-group">
                              <label class="calci-label" id="typeLabel">Monthly Investment Amount </label>
                              <!-- <label class="calci-label">I want to achieve</label> -->

                              <div class="calci-input-ctrl">
                                <input class="form-ctrl" type="tel" value="5,000" data-min="0" data-value="5,000"
                                  name="SIPamount" maxlength="12" />
                              </div>

                              <span class="calci-amount">Five thousand only</span>
                            </div>
                            <div class="form-group period-form-group">
                              <label class="calci-label tooltip-label">
                                For a period of <span class="label-tooltip" data-toggle="tooltip"
                                  title="Time duration for which you want to save and invest your money."></span>
                              </label>

                              <!-- <label class="calci-label tooltip-label">
                          In a period of <span class="label-tooltip" data-toggle="tooltip" title="Time duration for which you want to save and invest your money."></span>
                      </label> -->
                              <div class="calci-num-ctrl">
                                <input class="form-ctrl" value="5" data-step="1" data-max="31" data-unit="years"
                                  data-decimal="true" type="number" name="SIPperiod" />
                                <div class="sip-num-ctrl">
                                  <span class="increase"></span>
                                  <span class="decrease"></span>
                                </div>
                                <span class="input-prop year">years</span>
                              </div>
                              <span class="calci-amount"></span>
                              <ul class="interest-tenure hide">
                                <li class="active"><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid once every year">Yearly</span>
                                </li>
                                <li><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid once every three months.">Quarterly</span>
                                </li>
                                <li><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid each month">Monthly</span></li>
                              </ul>
                            </div>
                            <div class="form-group">
                              <label class="calci-label tooltip-label">
                                My Investment Strategy
                                <span class="label-tooltip" data-toggle="tooltip"
                                  title="Select your investment strategy based on the risk appetite or enter the expected return rate using custom option."></span>
                              </label>
                              <div class="calci-num-ctrl calci-num-ctrl-div">
                                <div class="dropdown-wrap sip-dropdown-wrap">
                                  <input type="text" class="form-ctrl selected_input" data-value="1" value="Aggressive"
                                    readonly name="strategy" />
                                  <span class="input-prop percentage sip-interest-prop hide">
                                    %
                                  </span>
                                  <ul class="dropdown-select sip-dropdown-select" id="strategy">

                                    <li data-value="Aggressive" class="item">Aggressive</li>
                                    <li data-value="Conservative" class="item">Conservative</li>
                                    <li data-value="Balanced" class="item">Balanced</li>
                                    <!-- <li data-value="Custom" class="item">Custom</li> -->

                                  </ul>
                                  <span class="dropdown-arrow"></span>
                                </div>
                              </div>
                              <div class="alerts-msg strategy-alert">This might give you <span
                                  class="green-bold">12%</span> returns</div>
                            </div>
                            <div class="form-group">
                              <div class="calci-button-ctrl">
                                <button id="calculate" class="cta cta-hollow SIPCalculate">Calculate</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="calculation-content primary">
                        <div class="calculation-result">
                          <div class="row-flex">

                            <div class="col-12 nopadding">
                              <div class="main-body" id="SIPfd_result">
                                <p class="post-tax-title visible-xs text-center" style="padding-bottom: 13px;">Potential
                                  Returns</p>

                                <div class="visible-goal hide">
                                  <div class="main-heading row-flex justify-content-between" style="padding: 10px;">
                                    <div class="col-5 col-xs">
                                      <div class="post-tax-block">
                                        <div class="post-tax-switch">
                                          <span class="light-label">Adjust for Inflation </span>
                                          <label class="calci-switch" for="inflation_toggle">
                                            <input class="calci-radio-btn-inflation" type="radio"
                                              name="inflation_toggle" id="inflation_toggle" /><span
                                              class="rounder"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-7 col-xs">
                                      <div class="tax-slab-box inflation-box hide">
                                        <div class="main-box">
                                          <span class="light-label">Assumed inflation @</span>
                                          <ul class="percent-values inflation-values">
                                            <li class="active">4%</li>
                                            <li>6%</li>
                                            <li>8%</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <ul class="table-listing kirby-table-listing">
                                  <li>
                                    <span class="property">
                                      Total Invested
                                    </span>
                                    <span class="value" id="SIPinvesdtedAmount"> ₹<span class="">3 Lacs</span> </span>
                                  </li>
                                  <li>
                                    <span class="property">
                                      <span class="property-child">
                                        <span id="second-label">Gains</span>
                                        <!-- <span class="light-green hide" id="extraInterest">(+0.25% extra)</span> -->
                                      </span>
                                    </span>
                                    <span class="value" id="SIPInterestGain"> ₹<span class=""
                                        data-prevalue="112432">1.12 Lacs</span> </span>
                                  </li>
                                  <li>
                                    <span class="property">
                                      <span id="third-label" class="property-child">
                                        Future Value
                                      </span>
                                    </span>
                                    <span class="value" id="SIPmaturityAmount"> ₹<span class=""
                                        data-prevalue="412432">4.12 Lacs</span> </span>
                                  </li>
                                </ul>
                                <hr class="nomargin" />
                                <div class="graphic-content mt-20">
                                  <p class="hidden-xs graph-title" style="color: inherit;">Potential Returns</p>
                                  <div class="graphic-body bar-graphic-body">
                                    <span class="left-up-arrow grey-dot hide">Total invested</span>
                                    <span class="right-up-arrow grey-dot hide"> Interest earned</span>
                                    <div class="chart-box">
                                      <canvas id="sipChart"></canvas>
                                    </div>
                                    <div class="about-chart bar-about">
                                      <span class="color-rect amt-principal">Total invested </span>
                                      <span class="color-rect amt-interest">Gains</span>
                                    </div>
                                  </div>
                                </div>

                                <div class="summary">
                                  <div class="summary-label"></div>
                                  <div class="summary-list sip-summary"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="visible-xs" style="width: 100%; padding: 0px 12px;">
                          <hr style="margin-top: 0px;" />
                        </div>
                      </div>
                    </div>

                    <div class="lumpsum-window hide">
                      <div class="cal-tax-exemption">
                        <!-- <div class="tax-form-heading row-flex justify-content-center">
                                      <p class="section-title-sm">Calculate the future value of your mutual fund investment</p>
                                  </div> -->
                        <div class="tax-form-heading row-flex justify-content-center">
                          <ul class="switch-time mf-switch">
                            <li>Monthly SIP</li>
                            <li class="active" style="padding: 10px 0px;">Lumpsum</li>
                          </ul>
                        </div>
                        <div class="calculator-form pt-10">
                          <div class="row-flex hide">
                            <div class="flex-with-no-space detailType">
                              <label class="radio-btn type2 mrgn19"> <input type="radio" class="radio-btn-input circle"
                                  checked name="i_know" value="investmentDetails" /><span></span> I know investment
                                amount </label>
                              <label class="radio-btn type2"> <input type="radio" class="radio-btn-input circle"
                                  name="i_know" value="goalDetails" /><span></span> I know the target amount </label>
                            </div>
                          </div>
                          <div class="row-flex">
                            <div class="form-group">
                              <label class="calci-label" id="typeLabel">I want to invest lumpsum of</label>
                              <!-- <label class="calci-label">I want to achieve</label> -->

                              <div class="calci-input-ctrl">
                                <input class="form-ctrl" type="tel" value="50,000" data-min="0" data-value="50,000"
                                  name="amount" maxlength="12" />
                              </div>

                              <span class="calci-amount">Fifty thousand only</span>
                            </div>
                            <div class="form-group period-form-group">
                              <label class="calci-label tooltip-label">
                                <span class="period-label">For a period of</span> <span class="label-tooltip"
                                  data-toggle="tooltip"
                                  title="Time duration for which you want to save and invest your money."></span>
                              </label>

                              <!-- <label class="calci-label tooltip-label">
                          In a period of <span class="label-tooltip" data-toggle="tooltip" title="Time duration for which you want to save and invest your money."></span>
                      </label> -->
                              <div class="calci-num-ctrl">
                                <input class="form-ctrl" value="5" data-step="1" data-max="31" data-unit="years"
                                  data-decimal="true" type="number" name="period" />
                                <div class="lumpsum-num-ctrl">
                                  <span class="increase"></span>
                                  <span class="decrease"></span>
                                </div>
                                <span class="input-prop year">years</span>
                              </div>
                              <span class="calci-amount"></span>
                              <ul class="interest-tenure hide">
                                <li class="active"><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid once every year">Yearly</span>
                                </li>
                                <li><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid once every three months.">Quarterly</span>
                                </li>
                                <li><span data-placement="bottom" data-toggle="tooltip" title=""
                                    data-original-title="Interest is calculated and paid each month">Monthly</span></li>
                              </ul>
                            </div>
                            <div class="form-group">
                              <label class="calci-label tooltip-label">
                                My Investment Strategy
                                <span class="label-tooltip" data-toggle="tooltip"
                                  title="Select your investment strategy based on the risk appetite or enter the expected return rate using custom option."></span>
                              </label>
                              <div class="calci-num-ctrl calci-num-ctrl-div">
                                <div class="dropdown-wrap lumpsum-dropdown-wrap">
                                  <input type="text" class="form-ctrl selected_input" data-value="1" value="Aggressive"
                                    readonly name="strategy" />
                                  <span class="input-prop percentage lumpsum-interest-prop hide">
                                    %
                                  </span>
                                  <ul class="dropdown-select lumpsum-dropdown-select" id="strategy">
                                    <li data-value="Aggressive" class="item">Aggressive</li>
                                    <li data-value="Conservative" class="item">Conservative</li>
                                    <li data-value="Balanced" class="item">Balanced</li>
                                    <!-- <li data-value="Custom" class="item">Custom</li> -->
                                  </ul>
                                  <span class="dropdown-arrow"></span>
                                </div>
                              </div>
                              <div class="alerts-msg strategy-alert">This might give you <span
                                  class="green-bold">12%</span> returns</div>
                            </div>
                            <div class="form-group">
                              <div class="calci-button-ctrl">
                                <button id="calculate" class="cta cta-hollow LumpsumCalculate">Calculate</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="calculation-content primary">
                        <div class="calculation-result">
                          <div class="row-flex">

                            <div class="col-12">
                              <div class="main-body" id="fd_result">
                                <p class="post-tax-title visible-xs text-center" style="padding-bottom: 13px;">Potential
                                  Returns</p>


                                <div class="visible-goal hide">
                                  <div class="main-heading row-flex justify-content-between" style="padding: 10px;">
                                    <div class="col-7 col-xs">
                                      <div class="post-tax-block" style="padding: 4px 0px;">
                                        <div class="post-tax-switch">
                                          <span class="light-label">Adjust target amount for Inflation? </span>
                                          <label class="calci-switch" for="inflation_toggle">
                                            <input class="calci-radio-btn-inflation" type="radio"
                                              name="inflation_toggle" id="inflation_toggle" /><span
                                              class="rounder"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-5 col-xs">
                                      <div class="tax-slab-box inflation-box hide">
                                        <div class="main-box">
                                          <span class="light-label">Inflation @</span>
                                          <ul class="percent-values inflation-values">
                                            <li class="active">4%</li>
                                            <li>6%</li>
                                            <li>8%</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <ul class="table-listing kirby-table-listing">
                                  <li>
                                    <span class="property">
                                      <span id="first-label">Total invested</span>
                                    </span>
                                    <span class="value" id="invesdtedAmount"> ₹<span class="">50,000</span> </span>
                                  </li>
                                  <li>
                                    <span class="property">
                                      <span class="property-child">
                                        <span id="second-label">Gains</span>
                                        <!-- <span class="light-green hide" id="extraInterest">(+0.25% extra)</span> -->
                                      </span>
                                    </span>
                                    <span class="value" id="InterestGain"> ₹<span class=""
                                        data-prevalue="38117">38,117</span> </span>
                                  </li>
                                  <li>
                                    <span class="property">
                                      <span id="third-label" class="property-child">
                                        Future Value
                                      </span>
                                    </span>
                                    <span class="value" id="maturityAmount"> ₹<span class=""
                                        data-prevalue="88118">88,118</span> </span>
                                  </li>
                                </ul>
                                <hr />
                                <div class="graphic-content">
                                  <p class="hidden-xs graph-title" style="color: inherit;">Potential Returns</p>
                                  <div class="graphic-body bar-graphic-body">
                                    <span class="left-up-arrow grey-dot hide">Total invested</span>
                                    <span class="right-up-arrow grey-dot hide"> Interest earned</span>
                                    <div class="chart-box">
                                      <canvas id="myChart"></canvas>
                                    </div>
                                    <div class="about-chart bar-about">
                                      <span class="color-rect amt-principal">Total invested </span>
                                      <span class="color-rect amt-interest">Gains</span>
                                    </div>
                                  </div>
                                </div>

                                <div class="summary">
                                  <div class="summary-label"></div>
                                  <div class="summary-list lumpsum-summary">
                                    <ul style="font-size: 14px; color: #666666; line-height: 18px; font-weight: 400;">
                                      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur urna lorem,
                                        scelerisque at diam vitae, blandit aliquet eros. Vestibulum in pretium purus....
                                      </li>
                                      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur urna lorem,
                                        scelerisque at diam vitae, blandit aliquet eros.</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="visible-xs" style="width: 100%; padding: 0px 12px;">
                          <hr style="margin-top: 0px;" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- New Calculator -->
                  <div class="">
                    <!-- <span class="pt-30">Mutual Funds Returns Calculator</span> -->
                    <div>
                      <div class="Fill_Tabs pt-32">
                        <ul class="nav nav-tabs border-0">
                            <li>
                                <a class="active show" data-toggle="tab" href="#SIP">Monthly - SIP</a>
                            </li>
                            <li>
                                <a data-toggle="tab" href="#Lumpsum">Lumpsum</a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content TabContentData">
                        <div id="SIP" class="tab-pane fade show active">
                      <div class="CalcGrid">
                        <div class="Calc">
                          <div class="d-flex justify-content-between align-items-center mt-20">
                            <label for="">Monthly Investment Amount (&#8377;) </label>
                            <!-- (<i class="fa fa-inr Bracket"></i>) -->
                            <div class="BorderBtm">
                              <input type="text" class="CommonTextBox numonly text-right" id=""
                              [(ngModel)]="InvestedAmount" (blur)="onInvestedAmountValue($event.target.value)"
                              placeholder="Amount">
                              <span class="RupeeIcn">₹</span>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between align-items-center mt-20">
                            <label for="">For a period of (M)</label>
                            <div class="BorderBtm">
                              <input type="text" class="CommonTextBox numonly text-right" id=""
                              [(ngModel)]="InvestmentPeriod" (blur)="onInvestmentPeriodValue($event.target.value)"
                              placeholder="Months">
                              <span class="Icn">M</span>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between align-items-center mt-20">
                            <label for="">Expected Returns (%)</label>
                            <div class="BorderBtm">
                              <input type="text" class="CommonTextBox numonly text-right" [(ngModel)]="ExpectedReturnsLumpsum"
                              (blur)="onExpectedReturnsValue($event.target.value)" placeholder="Returns" />
                              <span class="Icn"><b>%</b></span>
                            </div>
                          </div>
                          <div class="text-center mt-40">
                            <button type="submit" class="cta sb-primary-cta-button w-100 py-2"
                              (click)="OnChangeCalculator()">Calculate</button>
                          </div>
                        </div>
                        <div class="BGChart">
                          <div class="ChartAndReturn BGChart pt-4">
                            <div id="SipChart1" class="GoalChart"></div>
                            <div class="d-flex PercentData">
                              <div class="mr-40">
                                <div class="d-flex justify-content-center align-items-center">
                                  <div class="Square SquareBlue"></div><span>Investment</span>
                                </div>
                                <div class="">
                                  <div class="Percent">{{InvestmentPercent | number : '1.1-1' }} %</div>
                                  </div>
                              </div>
                              <div>
                                <div class="d-flex justify-content-center align-items-center">
                                  <div class="Square SquareGreen"></div><span>Earnings</span>
                                </div>
                                <div class="">
                                  <div class="Percent">{{GainPercent | number : '1.1-1' }} %</div>
                                  </div>
                              </div>
                          </div>
                          </div>
                          <div class="Investment">
                            <strong class="TotalAmount">Rs. {{FutureValue.toLocaleString("en-IN", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0 })}}</strong>
                            <div class="Inv_Amt">Will be potential market value if <strong class="Inv_Period">Rs.
                                {{InvestedAmount.toLocaleString("en-IN", { minimumFractionDigits: 0,
                                maximumFractionDigits: 0 })}}</strong> is invested </div>
                            <div class="Inv_Amt">over a period of
                              <strong class="">{{InvestmentPeriod}} Months</strong>, giving potential gain of <strong class="Inv_FGain">Rs.
                                {{FutureGain.toLocaleString("en-IN", {
                                minimumFractionDigits: 0, maximumFractionDigits: 0 })}}</strong>
                            </div>
                            <div class="Inv_Gain"></div>
                          </div>
                        </div>
                      </div>
                        </div>
                        <div id="Lumpsum" class="tab-pane fade">
                          <div class="CalcGrid">
                            <div class="Calc">
                              <div class="d-flex justify-content-between align-items-center mt-20">
                                <label for="">I want to invest lumpsum of (&#8377;)</label>
                                <div class="BorderBtm">
                                  <input type="text" class="CommonTextBox numonly text-right" id=""
                                  [(ngModel)]="InvestedAmountLumpsum" (blur)="onInvestedAmountValueLumpsum($event.target.value)"
                                  placeholder="Amount">
                                  <span class="RupeeIcn">₹</span>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mt-20">
                                <label for="">For a period of (Y)</label>
                                <div class="BorderBtm">
                                  <input type="text" class="CommonTextBox numonly text-right" id=""
                                  [(ngModel)]="InvestmentPeriodLumpsum" (blur)="onInvestmentPeriodValueLumpsum($event.target.value)"
                                  placeholder="Years">
                                  <span class="Icn">Y</span>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mt-20">
                                <label for="">Expected Returns (%)</label>
                                <div class="BorderBtm"><input type="text" class="CommonTextBox numonly text-right" [(ngModel)]="ExpectedReturnsLumpsum"
                                  (blur)="onExpectedReturnsValueLumpsum($event.target.value)" placeholder="Returns" />
                                  <span class="Icn"><b>%</b></span>
                                </div>
                              </div>
                              <div class="text-center mt-40">
                                <button type="submit" class="cta sb-primary-cta-button w-100 py-2"
                                  (click)="OnChangeCalculatorLumpSum()">Calculate</button>
                              </div>
                            </div>
                            <div class="BGChart">
                              <div class="ChartAndReturn BGChart pt-4">
                                <div id="LumpsumChart" class="GoalChart"></div>
                                <div class="d-flex PercentData">
                                  <div class="mr-40">
                                    <div class="d-flex justify-content-center align-items-center">
                                      <div class="Square SquareBlue"></div> <span>Investment</span>
                                    </div>
                                    <div class="Percent">{{InvestmentPercentLumpsum | number : '1.1-1' }} %</div>
                                  </div>
                                  <div>
                                    <div class="d-flex justify-content-center align-items-center">
                                      <div class="Square SquareGreen"></div><span>Earnings</span>
                                    </div>
                                    <div class="Percent">{{GainPercentLumpsum | number : '1.1-1' }} %</div>
                                  </div>
                              </div>
                              </div>
                              <div class="Investment">
                                <div class="TotalAmount">Rs. {{FutureValueLumpsum.toLocaleString("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0 })}}</div>
                                <div class="Inv_Amt">Will be potential market value if <strong class="Inv_Period">Rs.
                                    {{InvestedAmountLumpsum.toLocaleString("en-IN", { minimumFractionDigits: 0,
                                    maximumFractionDigits: 0 })}}</strong> is invested</div>
                                    <div class="Inv_Amt">over a period of
                                      <strong class="">{{InvestmentPeriodLumpsum}} years</strong>, giving potential gain of <strong class="Inv_FGain">Rs.
                                        {{FutureGainLumpsum.toLocaleString("en-IN", {
                                        minimumFractionDigits: 0, maximumFractionDigits: 0 })}}</strong>
                                    </div>
                                <!-- <div class="Inv_Gain"></div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
              </section>



            </main>
          </div>

        </div>
      </div>
    </div>



  </main>



</main>
<IFA-footer></IFA-footer>
